export default __webpack_public_path__ + "static/media/cherry.95318387.ogg";